import { string } from 'prop-types';
import React from 'react';

import s from './index.module.css';

import OrdersList from './OrdersList';

const Orders = (props) => {
  const header = <h3 className={s.ordersListHeader}>Статус заказов</h3>;
  
  return (
    <div className={s.ordersWrapper}>
      {header}
      <OrdersList />
      {/* Убрать комментарии после прояснения */}
      {/* 
        <a href={ORDER_LINK} className={s.allOrdersLink}>
          <div className={s.allOrdersLinkWrapper}>Все заказы <span><ArrowIcon /></span></div>
        </a> 
      */}
    </div >
  )
};

Orders.propTypes = {
  className: string,
  wrapperClassName: string,
};

export default Orders;
